import * as React from 'react';
import { createRoot } from 'react-dom/client';

import SignupPage from '@/pages/Signup';
import { renderWithUiRoot, resolveReactMountContainer } from '@/js/wisemetering/ui/render_with_ui_root';

WiseMetering.Views.Signup = Backbone.Marionette.View.extend({
    id: 'react-container',
    className: 'tailwind-container',

    onShow: function() {
        const container = resolveReactMountContainer(this);
        const root = createRoot(container);

        renderWithUiRoot(root, container, <SignupPage/>);
    }
});
